import { render, staticRenderFns } from "./ContestPdf.vue?vue&type=template&id=60d1d396&scoped=true&"
import script from "./ContestPdf.vue?vue&type=script&lang=ts&"
export * from "./ContestPdf.vue?vue&type=script&lang=ts&"
import style0 from "./ContestPdf.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ContestPdf.vue?vue&type=style&index=1&id=60d1d396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1d396",
  null
  
)

export default component.exports